export const NaturePeopleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.04899 9.00628C3.80838 9.00628 4.42399 8.39067 4.42399 7.63128C4.42399 6.87188 3.80838 6.25628 3.04899 6.25628C2.2896 6.25628 1.67399 6.87188 1.67399 7.63128C1.67399 8.39067 2.2896 9.00628 3.04899 9.00628Z"
        fill="currentColor"
      />
      <path
        d="M19.2465 7.32878C19.2465 3.78128 16.3773 0.912109 12.8298 0.912109C9.28232 0.912109 6.41316 3.78128 6.41316 7.32878C6.41316 10.5096 8.72316 13.1404 11.7573 13.6446V17.2563H4.42399V14.5063H5.34066V10.8396C5.34066 10.3354 4.92816 9.92294 4.42399 9.92294H1.67399C1.16982 9.92294 0.757324 10.3354 0.757324 10.8396V14.5063H1.67399V19.0896H16.3407V17.2563H13.5907V13.6996C16.7715 13.3238 19.2465 10.6196 19.2465 7.32878ZM12.8298 11.9121C10.2998 11.9121 8.24649 9.85878 8.24649 7.32878C8.24649 4.79878 10.2998 2.74544 12.8298 2.74544C15.3598 2.74544 17.4132 4.79878 17.4132 7.32878C17.4132 9.85878 15.3598 11.9121 12.8298 11.9121Z"
        fill="currentColor"
      />
    </svg>
  );
};
